<template>
  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    <div>
      <Link v-bind:href="$route('dashboard')">
        <Logo />
      </Link>
    </div>

    <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md sm:rounded-lg">
      <form v-on:submit.prevent="form.post($route('login'))">
        <!-- Email Address -->
        <div class="form-group">
          <Listbox as="div" v-model="selectedUser">
            <ListboxLabel class="block text-sm font-medium text-gray-700">Find your name. Hopefully it isn't last. HAHAHA!</ListboxLabel>
            <div class="relative mt-1">
              <ListboxButton class="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 sm:text-sm">
                <span class="block truncate">{{ selectedUser.name }}</span>
                <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <ChevronUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                </span>
              </ListboxButton>

              <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                <ListboxOptions class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">

                  <ListboxOption as="template" v-for="user in users" v-bind:key="user.id" v-bind:value="user" v-slot="{ active, selected }">
                    <li v-bind:class="[active ? 'text-white bg-primary-600' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9']">
                      <span v-bind:class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">{{ user.name }}</span>

                      <span v-if="selected" v-bind:class="[active ? 'text-white' : 'text-primary-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                        <CheckIcon class="h-5 w-5" aria-hidden="true" />
                      </span>
                    </li>
                  </ListboxOption>
                </ListboxOptions>
              </transition>
            </div>
          </Listbox>

          <span v-if="form.errors.email" class="invalid-feedback" role="alert">
            <strong>{{ form.errors.email }}</strong>
          </span>
        </div>

        <!-- Password -->
        <div class="form-group">
          <label for="password">
            Password
          </label>

          <input v-model="form.password" class="form-control" id="password" type="password"  required="required" autocomplete="false">
          <span v-if="form.errors.password" class="invalid-feedback" role="alert">
            <strong>{{ form.errors.password }}</strong>
          </span>
        </div>

        <!-- Remember Me -->
        <div class="block mt-4">
          <label for="remember_me" class="inline-flex items-center">
            <input v-model="form.remember" id="remember_me" type="checkbox" class="rounded border-gray-300 text-primary-600 shadow-sm focus:border-gray-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50">
            <span class="ml-2 text-sm text-gray-600">Remember me</span>
          </label>
        </div>

        <div class="flex items-center justify-end mt-4">
          <Link class="underline text-sm text-gray-600 hover:text-gray-900" v-bind:href="$route('password.request')">
            Forgot your password?
          </Link>

          <button type="submit" class="btn btn-primary ml-3">
            Log in
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { Link, useForm } from "@inertiajs/vue3";
import { Listbox, ListboxLabel, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/vue";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/vue/20/solid";

import Logo from "../Layouts/Logo";

const form = useForm({
  email: null,
  password: null,
  remember: true,
});

const { users } = defineProps([ 'users' ])

let selectedUser = ref({
  id: null,
  name: 'Select your name',
  email: null
});
let query = ref('');

watch(
  () => selectedUser.value,
  user => {
    if (user) {
      form.email = user.email;
    }
  },
);
</script>
